import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select, {
  SelectChangeEvent,
  SelectProps as MUISelectProps,
} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import commons from '../../../assets/styles/commons';
import colors from '../../../assets/styles/colors';
import { ReactComponent as IconArrowDown } from '../../../assets/icons/icon-arrow-down.svg';
import { ReactComponent as IconArrowDownDisabled } from '../../../assets/icons/icon-arrow-down-disabled.svg';
import { borderColor } from '@mui/system';

interface CustomizedInputsProps
  extends Omit<MUISelectProps, 'defaultValue' | 'value' | 'onChange'> {
  label: string;
  defaultValue: string;
  options: { value: string; label: string }[];
  value?: string;
  onChange?: (event: SelectChangeEvent<unknown>) => void;
  style?: React.CSSProperties;
  size?: 'small' | 'medium';
  disabled?: boolean;
}

const CustomSelect = styled(Select)(({ theme, disabled }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
    color: colors.neutral.gray,
  },
  '& .MuiInputBase-input': {
    backgroundColor: disabled
      ? colors.neutral.superLightGray
      : colors.secondary.softBlue,
  },
}));

const SelectCustom: React.FC<CustomizedInputsProps> = ({
  label,
  defaultValue,
  options,
  value,
  onChange,
  style,
  size,
  disabled,
  ...selectProps
}) => {
  return (
    <Box component="div" sx={{ display: 'grid' }}>
      <FormControl size={size}>
        <InputLabel
          shrink
          variant="standard"
          sx={{
            fontFamily: commons.fontFamily,
            color: disabled ? colors.neutral.lightGray : colors.primary.orange,
            fontSize: 18,
            '&.Mui-focused': {
              color: disabled
                ? colors.neutral.lightGray
                : colors.primary.orange,
            },
            ...style,
          }}
        >
          {label}
        </InputLabel>
        <CustomSelect
          disableUnderline
          defaultValue={defaultValue}
          value={value}
          onChange={onChange}
          size={size}
          disabled={disabled}
          IconComponent={!disabled ? IconArrowDown : IconArrowDownDisabled}
          {...selectProps}
        >
          {options.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    </Box>
  );
};

export default SelectCustom;
